import { gql } from '@apollo/client';

const getMyJackSyncTaskStatus = gql`
  query getMyJackSyncTaskStatus {
    getMyJackSyncTaskStatus {
      status
      progress
    }
  }
`;

export default getMyJackSyncTaskStatus;
